import { CentraleData } from '../../domain/plantSelect.types'
import { useFetchApi } from '../../adapter/fetchApi'

export const useGetAllUserPlantsApi = () => {
  const fetchApi = useFetchApi()
  return {
    getAllUserPlants: async (): Promise<CentraleData[] | undefined> => {
      return (await fetchApi<CentraleData[]>('users/current/centrales')) as
        | CentraleData[]
        | undefined
    },
  }
}
